import { useEffect } from 'react';

const STYLE_ID = 'suppress-webpack-error-overlay';
const OVERLAY_SELECTORS = [
    '#webpack-dev-server-client-overlay',
    '#webpack-dev-server-client-overlay-div',
    'iframe#webpack-dev-server-client-overlay',
].join(', ');

/**
 * Hide CRA's global webpack compile error overlay while report dashboard codegen runs.
 * Broken intermediate `.tsx` files under `generated/` still trigger dev-server compiles;
 * this keeps the in-app loading state visible until validation completes.
 * Applies whenever the CRA dev server is running (local or deployed `npm start`); no-op for
 * static production bundles where the overlay is not injected.
 */
export function useSuppressWebpackErrorOverlay(suppress) {
    useEffect(() => {
        if (!suppress) {
            return undefined;
        }

        let styleEl = document.getElementById(STYLE_ID);
        if (!styleEl) {
            styleEl = document.createElement('style');
            styleEl.id = STYLE_ID;
            styleEl.textContent = `${OVERLAY_SELECTORS} { display: none !important; visibility: hidden !important; pointer-events: none !important; }`;
            document.head.appendChild(styleEl);
        }

        const hideOverlays = () => {
            document.querySelectorAll(OVERLAY_SELECTORS).forEach((el) => {
                el.style.setProperty('display', 'none', 'important');
                el.style.setProperty('visibility', 'hidden', 'important');
                el.style.setProperty('pointer-events', 'none', 'important');
            });
        };

        hideOverlays();

        const observer = new MutationObserver(hideOverlays);
        observer.observe(document.body, { childList: true, subtree: true });

        return () => {
            observer.disconnect();
            const el = document.getElementById(STYLE_ID);
            if (el) el.remove();
        };
    }, [suppress]);
}
